module.exports = __webpack_public_path__ + "media/images/ukrpol-text-65976a869c99bb0aefe9c1e3c177a0a6.svg";